import {useEditorRef} from "@udecode/plate/react";
import {ButtonWrapper} from "./_Button";
import {isBlockActive, toggleBlock} from "./utils";
import {ReactNode} from "react";

export const BlockButton = (props: {
    format: string,
    children: ReactNode,
    [key: string]: any
}) => {
    const { format, children, ...restProps } = props;
    const editor = useEditorRef();

    return (
        <ButtonWrapper
            pressed={isBlockActive(editor, [format])}
            onClick={() => toggleBlock(editor, format)}
            onMouseDown={event => event.preventDefault()}
            {...restProps}
        >
            {children}
        </ButtonWrapper>
    );
};